/*
 * Keeps both phone header buttons (.site-header__mobile-cta-row--two) on a
 * single line whatever their merchant-entered text: when a label doesn't fit
 * its button, both labels shrink together in 0.25px steps (down to 9px) so
 * the pair stays visually matched. Re-runs whenever the row resizes.
 */
const MIN_FONT_SIZE = 9;
const STEP = 0.25;

function contentWidth(button) {
  const label = button.querySelector('span');
  const icon = button.querySelector('svg');
  const style = getComputedStyle(button);
  let width = label ? label.getBoundingClientRect().width : 0;
  if (icon) width += icon.getBoundingClientRect().width + parseFloat(style.columnGap || 0);
  return width + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
}

function overflows(button) {
  return contentWidth(button) > button.getBoundingClientRect().width + 0.5;
}

function fit(row) {
  const buttons = Array.from(row.querySelectorAll('.site-header__mobile-cta'));
  if (!buttons.length || row.offsetParent === null) return;

  buttons.forEach((button) => button.style.removeProperty('font-size'));
  let size = parseFloat(getComputedStyle(buttons[0]).fontSize);

  while (size > MIN_FONT_SIZE && buttons.some(overflows)) {
    size = Math.max(MIN_FONT_SIZE, size - STEP);
    buttons.forEach((button) => button.style.setProperty('font-size', `${size}px`));
  }
}

document.querySelectorAll('.site-header__mobile-cta-row--two').forEach((row) => {
  if (row.dataset.ctaFitBound === 'true') return;
  row.dataset.ctaFitBound = 'true';

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => fit(row));
  };

  new ResizeObserver(schedule).observe(row);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
});
